import React, { useState } from 'react';
import Logo1 from 'Icons/RMlogo.png';
import { setCookie } from 'utils/Global';
import { useNavigate } from 'react-router-dom';
import { EFeatureDescriptions, EFeatureTypes } from 'enums/EFeatureTypes';
import { useRMDispatch } from 'redux/hooks';
import { incCookieCounter } from 'redux/reducers/commonReducer';
import { FmlxButton, FmlxCard, FmlxRadioButton } from 'fmlx-common-ui';
import LicenseHeader from './LicenseHeader';

const FeatureSelection = () => {
  const navigate = useNavigate();
  const [feature, setFeature] = useState<number>(0);
  const dispatch = useRMDispatch();

  const handleSelectFeature = () => {
    if (feature === 1) {
      setCookie(EFeatureTypes.SelectedFeature, EFeatureTypes.RMLite);
    } else {
      setCookie(EFeatureTypes.SelectedFeature, EFeatureTypes.RM);
    }
    dispatch(incCookieCounter());
    navigate('/', { replace: true });
  };

  const options = [
    {
      content: EFeatureTypes.RockMakerTitle,
      hint: EFeatureDescriptions.RockMaker,
      type: FmlxRadioButton.HintType.INFORMATION,
      disabled: false,
    },
    {
      content: EFeatureTypes.RockMakerLiteTitleUppercase,
      hint: EFeatureDescriptions.RockMakerLite,
      type: FmlxRadioButton.HintType.INFORMATION,
      disabled: false,
    },
  ];

  return (
    <div id="feature-selection-main-container" className="mainContainer">
      <div id="feature-selection-header-row" className="headerRow">
        <div id="feature-selection-header-logo" className="headerLogo">
          <img id="feature-selection-img-header-logo-1" src={Logo1} />
        </div>
      </div>
      <div id="feature-selection-inner-container" className="innerContainer">
        <FmlxCard
          id="feature-selection-fmlx-card"
          disabled={false}
          draggable={false}
          selectable={false}
          selected={false}
          type=""
          variant={FmlxCard.Variant.OUTLINED}
          className="feature-selection-modal"
        >
          <FmlxCard.Header className="flex flex-col items-center justify-center mt-[-8px] px-2">
            <LicenseHeader />
            <div className="font-[Roboto] text-base font-normal text-[#F7A246] self-start mt-[-8px] px-4">
              Feature Selection
            </div>
          </FmlxCard.Header>
          <FmlxCard.Body className="flex flex-col h-full border-y-[#CACACA] border-x-0 border-y-[1px] border-solid py-4">
            <div className="font-[Roboto] text-sm font-normal text-[#5D5D5D] px-2">
              Please select the feature you want to use
            </div>
            <div
              id="feature-selection-license-radio-button-wrapper"
              className="feature-selection-radio-button-wrapper"
            >
              <FmlxRadioButton
                id="feature-selection-license-radio-button"
                selectedIndex={feature}
                size={FmlxRadioButton.Size.SMALL}
                items={options}
                alignment={FmlxRadioButton.Alignment.LEFT}
                onChange={(e) => setFeature(Number(e.index))}
              />
            </div>
          </FmlxCard.Body>
          <FmlxCard.Footer className="flex items-center justify-center py-4">
            <FmlxButton
              size={FmlxButton.Size.MEDIUM}
              label="SELECT"
              variant={FmlxButton.Variant.CONTAIN}
              type={FmlxButton.Type.PRIMARY}
              onClick={handleSelectFeature}
            />
          </FmlxCard.Footer>
        </FmlxCard>
      </div>
    </div>
  );
};

export default FeatureSelection;
